import { ActionTree } from 'vuex'
import { AppointmentState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<AppointmentState, RootState> = {
}
